import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useKSK2070_R01Store } from "src/containers/mes/KSK/KSK2070_R01/Store_KSK2070_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_KSK2070_R01 } from "./Content_KSK2070_R01";
import { SearchSection_KSK2070_R01 } from "./SearchSection_KSK2070_R01";
import { Table_KSK2070_R01 } from "./Table_KSK2070_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { GridRowData } from "./Dto_KSK2070_R01";

/**
 * 생산 실적 관리 컨테이너 컴포넌트
 * 생산 실적 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_KSK2070_R01 = () => {
    const { initData } = useKSK2070_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<GridRowData>>(null);

    // Content에서 액션바 핸들러 함수들을 가져옴
    const {
        fetchData,
        handleExcelClick,
    } = Content_KSK2070_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} // TODO: 저장 기능 구현 예정
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            
            {/* 생산 실적 검색 섹션 */}
            <SearchSection_KSK2070_R01 />
            
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    {/* 생산 실적 테이블 */}
                    <Table_KSK2070_R01 gridRef={gridRef} />
                </div>
            </div>
        </div>
    );
};
